export { FeaturedContent, type FeaturedContentProps } from "./FeaturedContent";
